import {
  CREATEUNIT,
  GETUNIT,
  UPDATEUNIT,
  DELETEUNIT,
  CREATECHARGESTYPE,
  GETCHARGESTYPE,
  UPDATECHARGESTYPE,
  DELETECHARGESTYPE,
  CREATECHARGESCHATEGORY,
  GETCHARGESCHATEGORY,
  UPDATECHARGESCHATEGORY,
  DELETECHARGESCHATEGORY,
  CREATECHARGE,
  GETCHARGE,
  UPDATECHARGE,
  DELETECHARGE,
  SERCHCHARG,
  GET_SERVICE,
  CREATE_SERVICE,
  UPDATE_SERVICE,
  DELETE_SERVICE,
  CREATESERVICECHARGE,
  GETSERVICECHARGE,
  UPDATESERVICECHARGE,
  DELETESERVICECHARGE,
  GET_MAPPING_DEPARTMENT,
  CREATE_MAPPING_DEPARTMENT,
  UPDATE_MAPPING_DEPARTMENT,
  DELETE_MAPPING_DEPARTMENT,
  GET_MAPPING_DOCTOR,
  CREATE_MAPPING_DOCTOR,
  UPDATE_MAPPING_DOCTOR,
  DELETE_MAPPING_DOCTOR,
  GET_MAPPING_CATEGORY,
  CREATE_MAPPING_CATEGORY,
  UPDATE_MAPPING_CATEGORY,
  DELETE_MAPPING_CATEGORY,
  GET_MAPPING_COSTCENTER,
  CREATE_MAPPING_COSTCENTER,
  UPDATE_MAPPING_COSTCENTER,
  DELETE_MAPPING_COSTCENTER,
} from "../actions/types";

const initialState = {
  chargestypeList: [],
  chargeschategoryList: [],
  chargesunitList: [],
  mappingdepartmentList: [],
  serviceChargeList: [],
  mappingDepartments: [],
  mappingDoctorsList: [],
  mappingCategoriesList: [],
  mappingCostCentersList: [],
  message: null,
};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case CREATEUNIT:
      return {
        ...state,
        chargesunitSaveStatus: action.payload.success,
      };
    case GETUNIT:
      return {
        ...state,
        chargesunitList: action.payload.data,
      };
    case UPDATEUNIT:
      return {
        ...state,
        chargesunitUpdateStatus: action.payload.success,
      };

    case DELETEUNIT:
      return {
        ...state,
        chargesunitDeleteStatus: action.payload.success,
      };

    case CREATECHARGESTYPE:
      return {
        ...state,
        chargestypeSaveStatus: action.payload.success,
      };
    case GETCHARGESTYPE:
      return {
        ...state,
        chargestypeList: action.payload.data,
      };
    case UPDATECHARGESTYPE:
      return {
        ...state,
        chargestypeUpdateStatus: action.payload.success,
      };

    case DELETECHARGESTYPE:
      return {
        ...state,
        chargestypeDeleteStatus: action.payload.success,
      };
    case CREATECHARGESCHATEGORY:
      return {
        ...state,
        chargeschategorySaveStatus: action.payload.success,
      };
    case GETCHARGESCHATEGORY:
      return {
        ...state,
        chargeschategoryList: action.payload.data,
      };
    case UPDATECHARGESCHATEGORY:
      return {
        ...state,
        chargeschategoryUpdateStatus: action.payload.success,
      };

    case DELETECHARGESCHATEGORY:
      return {
        ...state,
        chargeschategotyDeleteStatus: action.payload.success,
      };
    case CREATECHARGE:
      return {
        ...state,
        chargeSaveStatus: action.payload.success,
      };
    case GETCHARGE:
      return {
        ...state,
        chargeList: action.payload.data,
      };
    case UPDATECHARGE:
      return {
        ...state,
        chargeUpdateStatus: action.payload.success,
      };

    case DELETECHARGE:
      return {
        ...state,
        chargeDeleteStatus: action.payload.success,
      };
    case SERCHCHARG:
      return {
        ...state,
        serchchargeList: action.payload.data,
      };

    case GET_SERVICE:
      return { ...state, serviceList: action.payload };
    case CREATE_SERVICE:
    case UPDATE_SERVICE:
    case DELETE_SERVICE:

    case CREATESERVICECHARGE:
      return {
        ...state,
        serviceChargeSaveStatus: action.payload.success,
      };
    case GETSERVICECHARGE:
      return {
        ...state,
        serviceChargeList: action.payload.data,
      };
    case UPDATESERVICECHARGE:
      return {
        ...state,
        serviceChargeUpdateStatus: action.payload.success,
      };
    case DELETESERVICECHARGE:
      return {
        ...state,
        serviceChargeDeleteStatus: action.payload.success,
      };

    case CREATE_MAPPING_DEPARTMENT:
      return {
        ...state,
        mappingdepartmentSaveStatus: action.payload.success,
      };
    case GET_MAPPING_DEPARTMENT:
      return {
        ...state,
        mappingdepartmentList: action.payload.data,
      };
    case UPDATE_MAPPING_DEPARTMENT:
      return {
        ...state,
        mappingdepartmentUpdateStatus: action.payload.success,
      };

    case DELETE_MAPPING_DEPARTMENT:
      return {
        ...state,
        mappingdepartmentDeleteStatus: action.payload.success,
      };

    // ---- DOCTOR ----
    case GET_MAPPING_DOCTOR:
      return {
        ...state,
        mappingDoctorsList: action.payload?.data || [],
      };
    case CREATE_MAPPING_DOCTOR:
      return {
        ...state,
        mappingdoctorSaveStatus: action.payload?.success,
        message: action.payload,
      };
    case UPDATE_MAPPING_DOCTOR:
      return {
        ...state,
        mappingdoctorUpdateStatus: action.payload?.success,
        message: action.payload,
      };
    case DELETE_MAPPING_DOCTOR:
      return {
        ...state,
        mappingdoctorDeleteStatus: action.payload?.success,
        message: action.payload,
      };

    // ---- CATEGORY ----
    case GET_MAPPING_CATEGORY:
      return {
        ...state,
        mappingCategoriesList: action.payload?.data || [],
      };
    case CREATE_MAPPING_CATEGORY:
      return {
        ...state,
        mappingcategorySaveStatus: action.payload?.success,
        message: action.payload,
      };
    case UPDATE_MAPPING_CATEGORY:
      return {
        ...state,
        mappingcategoryUpdateStatus: action.payload?.success,
        message: action.payload,
      };
    case DELETE_MAPPING_CATEGORY:
      return {
        ...state,
        mappingcategoryDeleteStatus: action.payload?.success,
        message: action.payload,
      };

    // ---- COST CENTER ----
    case GET_MAPPING_COSTCENTER:
      return {
        ...state,
        mappingCostCentersList: action.payload?.data || [],
      };
    case CREATE_MAPPING_COSTCENTER:
      return {
        ...state,
        mappingcostcenterSaveStatus: action.payload?.success,
        message: action.payload,
      };
    case UPDATE_MAPPING_COSTCENTER:
      return {
        ...state,
        mappingcostcenterUpdateStatus: action.payload?.success,
        message: action.payload,
      };
    case DELETE_MAPPING_COSTCENTER:
      return {
        ...state,
        mappingcostcenterDeleteStatus: action.payload?.success,
        message: action.payload,
      };

    default:
      return state;
  }
}
